module.exports = __webpack_public_path__ + "static/media/ticket-alt.198c37c7.svg";